import axios from "axios";

export const getEventSponsors = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/eventsponsor/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const addEventSponsor = (eventSponsor) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventsponsor/addEventSponsor",
      eventSponsor
    )
    .then((res) => res.data);
};

export const deleteEventSponsor = (eventSponsorId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/eventsponsor/deleteEventSponsor/" +
        encodeURIComponent(eventSponsorId)
    )
    .then((res) => res);
};

export const editEventSponsor = (eventSponsor) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/eventsponsor/editeventsponsor",
      eventSponsor
    )
    .then((res) => res);
};
